import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { IndicatorFrequency } from "../models/indicator-frequency-model";

interface IndicatorFrequencyViewProps {
  frequency?: IndicatorFrequency | null;
  modified?: boolean;
  className?: string;
  placeholder?: string;
}

export const IndicatorFrequencyView: FC<IndicatorFrequencyViewProps> = ({ frequency, modified, placeholder }) => {
  const { t } = useTranslation("indicator");

  const displayText = useMemo(() => {
    if (!frequency) return placeholder ?? t("frequency.notAssigned");
    switch (frequency) {
      case "daily":
        return t("frequency.daily");
      case "weekly":
        return t("frequency.weekly");
      case "monthly":
        return t("frequency.monthly");
      case "quarterly":
        return t("frequency.quarterly");
      case "yearly":
        return t("frequency.yearly");
      default:
        return t("frequency.unknown");
    }
  }, [frequency, placeholder, t]);

  return (
    <div className="flex flex-row items-center gap-2">
      <span className="whitespace-nowrap">{displayText}</span>
      {modified && <div className="ml-1 h-1.5 w-1.5 rounded-full bg-muted-foreground"></div>}
    </div>
  );
};
